export default __webpack_public_path__ + "static/media/note.af397b4e.svg";